export const uploadTypeService = {
  gcs: "gcs",
  s3: "s3",
};
